module.exports = __webpack_public_path__ + "img/IT0000643843738.815f3c67.png";